export const HTTP_ERRORS = {
    _500: "Ha ocurrido un error al procesar la petición. Por favor, póngase en contacto con el administrador o vuelva a intentarlo más tarde.",
    _400: "Ha ocurrido un error en el envío de la petición.",
    _401: "No tiene permisos para ejecutar esta acción.",
    _600: "No tiene permisos para ver esa página",
    _EXCEPTION: "Ha ocurrido un error en la llamada al servicio.",
};
export const REQUIRED = "Campo obligatorio";